// Translations
import accessKeyInformationForm from '../components/access-key-information-form/translations/tr'

// Translation: Model > Access key manager > Access key managing dialog (Turkish)
export default Object.freeze({
	actions: {
		cancel: 'İptal',
		create: 'Oluştur',
		save: 'Kaydet'
	},
	components: { accessKeyInformationForm },
	message: {
		text: {
			information: 'Erişim anahtarınız oluşturuldu, ancak onu yalnızca şu an görebilirsiniz. Bu diyaloğu kapattığınızda tekrar görüntüleme şansınız olmayacak.',
			instructions: 'Lütfen bu gizli anahtarı güvenli bir yere kaydedin. Eğer kaybederseniz, yeni bir tane oluşturmanız gerekecek. Ek olarak, onu herkesle paylaşmamalısınız.'
		},
		title: 'Dikkatli ol!'
	},
	title: {
		creating: 'Erişim anahtarı oluştur',
		editing: 'Erişim anahtarını düzenle'
	}
})
